import { getAbTestAnalyticsEntries } from 'helpers/getAbTestAnalyticsEntries'
import { getAbTestVariantData } from 'helpers/getAbTestVariantData'
import { sendFbqEvent } from 'helpers/sendFbqEvent'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { eventLogger } from 'services/eventLogger.service'
import { useShallow } from 'zustand/shallow'
import { useZustandStore } from 'zustandGlobalStore'

export const useStartSessionEvent = (): void => {
  const { search } = useLocation()
  const {
    leadId,
    country,
    cohort,
    remoteConfigVariantData: remoteConfigVariant,
    growthbookVariantData,
    isEventLoggerInitialized,
    isSessionStartEventSent,
  } = useZustandStore(
    useShallow((state) => ({
      leadId: state.lead?.id,
      country: state.lead?.country,
      cohort: state.lead?.cohort || '',
      remoteConfigVariantData: state.firebaseRemoteConfigVariantData,
      growthbookVariantData: state.growthbookVariantData,
      isEventLoggerInitialized: state.isEventLoggerInitialized,
      isSessionStartEventSent: state.isSessionStartEventSent,
    })),
  )
  useEffect(() => {
    if (leadId) {
      sendFbqEvent('track', 'ViewContent', {}, { eventID: leadId })
    }
  }, [leadId])

  useEffect(() => {
    if (!isEventLoggerInitialized || isSessionStartEventSent) return

    const remoteConfigVariantData = getAbTestVariantData({
      firebaseRemoteConfigVariantData: remoteConfigVariant,
      growthbookVariantData,
      cohort,
      country,
      search,
    })
    const abTestEntries = getAbTestAnalyticsEntries({
      cohort,
      country,
      remoteConfigVariantData,
    })

    if (abTestEntries.length) {
      const keys = abTestEntries.map(({ key }) => key)
      const values = abTestEntries.map(({ value }) => value)
      const abVariant = keys.length === 1 ? keys[0] : keys
      const abSegmentName = values.length === 1 ? values[0] : values

      eventLogger.logSessionStarted({
        cohort,
        abVariant,
        abSegmentName,
      })
      useZustandStore.setState({ isSessionStartEventSent: true })
      eventLogger.logFbcSegmentActivated({
        abVariant,
        abSegmentName,
      })

      return
    }

    eventLogger.logSessionStarted({ cohort })
    useZustandStore.setState({ isSessionStartEventSent: true })
  }, [
    cohort,
    remoteConfigVariant,
    growthbookVariantData,
    country,
    isEventLoggerInitialized,
    isSessionStartEventSent,
    search,
  ])
}
